import { ColumnDef, createColumnHelper } from "@tanstack/react-table"
import type { Invoice } from "@tfg/db"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

import { DateCell } from "~/components/cells/DateCell.tsx"
import { DocumentActionsCell } from "~/components/cells/DocumentActionsCell.tsx"

const columnHelper = createColumnHelper<Invoice>()
export const useColumns = (orgName: string) => {
  const { t } = useTranslation("invoices")

  return useMemo<ColumnDef<Invoice, any>[]>(
    () => [
      columnHelper.accessor("issueDate", {
        header: t("columns.issueDate"),
        cell: (info) => <DateCell date={info.getValue()} format="lll" />,
      }),
      columnHelper.accessor("reference", {
        header: t("columns.reference"),
      }),
      columnHelper.accessor("amount", {
        header: t("columns.amount"),
        cell: (info) => t("intlCurrency", { value: info.getValue() }),
      }),
      columnHelper.display({
        header: t("columns.actions"),
        cell: ({ row: { original: invoice } }) =>
          invoice.documentId ? (
            <DocumentActionsCell
              documentName={`invoice-${orgName}-${invoice.createdAt}`}
              documentId={invoice.documentId}
            />
          ) : null,
      }),
    ],
    [orgName, t]
  )
}
